var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content.type==9&&_vm.content.show)?_c('div',{staticClass:"step1"},[_c('p',[_vm._v("素质项："+_vm._s(_vm.content.title))]),_vm._l((_vm.content.options),function(pep,zindex){return _c('RateScale',{attrs:{"content":pep},on:{"listenToChildEvent":_vm.selectAnswer}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }